export const unityOpenSiteModal = () => {
  (window as { [key: string]: any })["open_sit_modal"] = async (callback: Function) => {
    callback();
  };
};
